import { ObjectModel } from 'objectmodel';

const DeviceInfo = new ObjectModel({
  bookmarkSupported: Boolean,
  connection: {
    defaultServiceId: Number,
    imei: String,
    simMCC: [String, undefined, null],
    simMNC: [String, undefined, null],
    currentMCC: [String, undefined, null],
    currentMNC: [String, undefined, null],
    simMCC2: [String, undefined, null],
    simMNC2: [String, undefined, null],
    currentMCC2: [String, undefined, null],
    currentMNC2: [String, undefined, null],
    type: [String, undefined, null]
  },
  settings: {
    'deviceinfo.hardware': String,
    'deviceinfo.os': String,
    'deviceinfo.product_model': String,
    'deviceinfo.software': String,
    'deviceinfo.cu': String,
    'deviceinfo.platform_build_id': String,
    'deviceinfo.build_number': String,
    'deviceinfo.platform_version': String,
    'apps.serviceCenterUrl': String,
    'apps.serviceCenter.settingsEnabled': Boolean,
    'store.banner.enable': Boolean
  }
}).defaultTo({
  bookmarkSupported: false,
  settings: {
    'deviceinfo.hardware': 'unknown',
    'deviceinfo.os': 'unknown',
    'deviceinfo.product_model': 'unknown',
    'deviceinfo.software': 'unknown',
    'deviceinfo.cu': '4044O-2BAQUS1-R',
    'deviceinfo.platform_build_id': '',
    'deviceinfo.build_number': '',
    'deviceinfo.platform_version': '',
    'apps.serviceCenterUrl': 'https://api.kaiostech.com/v3.0',
    'apps.serviceCenter.settingsEnabled': false,
    'ril.data.defaultServiceId': '',
    'store.banner.enable': false
  }
});

export { DeviceInfo };



/** WEBPACK FOOTER **
 ** ./~/kaistore-post-messenger/src/models/DeviceInfo.js
 **/